<template>
  <div id="water-hazard-index">
    <router-view></router-view>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { createSurvey, updateSurvey } from '@/api/survey.api'
export default {
  name: 'WaterHazardIndex',
  beforeRouteLeave(to, from, next) {
    // if (navigator.onLine) this.$_saveDataToCould();
    next();
  },
  computed: {
    ...mapState({
      waterHazardSurvey: (state) => state.Surveys.waterHazard,
      user: (state) => state.User.user,
    }),
  },
  methods: {
    ...mapActions({
      updateSurvey: "Surveys/UPDATE_WATER_HAZARD",
    }),
    $_saveDataToCould() {
      if (this.waterHazardSurvey) {
        if (this.waterHazardSurvey.id) {
          const payload = {
            fields: {
              survey_data: JSON.stringify(this.waterHazardSurvey),
            },
          };
          updateSurvey(this.waterHazardSurvey.id, payload)
            .then((res) => { })
            .catch((err) => {
              // Better erorr handling
              console.log(err);
              if (err.response.data) {
                console.log(err.response.data);
              }
            });
        } else {
          const payload = {
            title: `${this.user.slug}-WaterShortageHazard`,
            author: this.user.id,
            status: "publish",
            tags: [40],
            content: `${this.user.slug}-WaterShortageHazard`,
            fields: {
              survey_data: JSON.stringify(this.waterHazardSurvey),
            },
          };

          createSurvey(payload)
            .then((res) => {
              const surveyData = JSON.parse(res.data.acf.survey_data);
              surveyData.id = res.data.id;
              this.updateSurvey(surveyData);
            })
            .catch((err) => {
              // Better erorr handling
              console.log(err);
              if (err.response.data) {
                console.log(err.response.data);
              }
            });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/* #water-hazard-index {
} */
</style>
